import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, Input } from 'antd';
import { toggleAgreementUpdateModal } from '../../redux/actions/agreement/toggleModals';
import { updateAgreement } from '../../redux/actions/agreement/updateAgreement';

class UpdateAgreementModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate(values.statement,
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update Agreement"
                key={this.props.agreement?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-agreement-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-agreement-form"
                    name="basic"
                    initialValues={{
                        statement: this.props.agreement?.statement
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="statement"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <Input.TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.agreement.updateVisible,
    loading: state.agreement.loading,
    token: state.auth.token,
    error: state.agreement.error,
    message: state.agreement.message,
    agreement:state.agreement.one
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (statement, token) => dispatch(updateAgreement(statement, token)),
    onClose: () => dispatch(toggleAgreementUpdateModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateAgreementModal);